import { PropsWithChildren, useImperativeHandle, useState } from 'react'

import { Flex } from 'antd'

import { isExcel, isPPT, isPdf } from '../../utils/mimeType'
import { DraggableModal } from '../DraggableModal'
import { WebOffice } from '../WebOffice'
import { OfficeType } from '../WebOffice/exports/sdk'

import { PreviewFileDownloadButton } from './DownloadButton'
import { PreviewFileProps, PreviewItem } from './interface'

export const PreviewOffice = ({
  ref,
  children
}: PropsWithChildren<PreviewFileProps>) => {
  const [file, setFile] = useState<PreviewItem>()

  useImperativeHandle(ref, () => {
    return {
      open(file) {
        setFile(file)
      }
    }
  })

  const officeType = isPdf(file?.type)
    ? OfficeType.Pdf
    : isExcel(file?.type)
      ? OfficeType.Spreadsheet
      : isPPT(file?.type)
        ? OfficeType.Presentation
        : OfficeType.Writer

  const modalTitle = (
    <Flex align='flex-end' gap={8}>
      <span>{file?.name}</span>
      <PreviewFileDownloadButton file={file} />
    </Flex>
  )

  return (
    <DraggableModal
      centered
      destroyOnHidden
      footer={null}
      open={!!file}
      title={modalTitle}
      width='90%'
      mask={{
        closable: false
      }}
      onCancel={() => setFile(undefined)}
    >
      {
        <WebOffice
          download
          readOnly
          saveAs
          fileId={`${file?.ossId}`}
          officeType={officeType}
          style={{
            height: '80vh'
          }}
        >
          {children}
        </WebOffice>
      }
    </DraggableModal>
  )
}
